import React, { useEffect, useState } from "react";
import Footer from "../layout/Footer";
import { useLocalStorage } from "../useLocalStorage";
import "./Profile.css";
import Swal from "sweetalert2";
import toast, { Toaster } from "react-hot-toast";
import M from "materialize-css";

import avatar from "../images/icon/avatar.png";
import { API_URL, numberWithCommas } from "../constant";

import jwt from "jsonwebtoken";
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import MemberCard from "./component/MemberCard";

const Profile = () => {
  const [token, setToken] = useLocalStorage("token", "");
  const [memberStatus, setMemberStatus] = useState("");
  const [sales, setSales] = useState([]);
  const [point, setPoint] = useState({});
  const [lastupdate, setLastUpdate] = useState({});
  const [user, setUser] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const notify = () => toast.error("Something went wrong!");

  function LogoutHandler(event) {
    Swal.fire({
      title: "Log Out",
      text: "Are you want to log out from this application?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#ff3d00",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, I'm sure!`,
    }).then((result) => {
      if (result.isConfirmed) {
        setToken("");
        window.location = "/";
      }
    });
  }

  function UpgradeHandler() {
    Swal.fire({
      title: "Upgrade Member",
      text: "Buy with a minimum purchase of 600k and become a reseller!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#ff3d00",
      cancelButtonColor: "#d33",
      confirmButtonText: `Go, become a reseller!`,
    }).then((result) => {
      if (result.isConfirmed) {
        // setToken("");
        window.location = "/search";
      }
    });
  }

  function goToHandler(url) {
    window.location = url;
  }

  function goToHandlerBlank(url) {
    // var strWindowFeatures = "location=yes,height=570,width=520,scrollbars=yes,status=yes";
    // var win = window.open(url, "_blank", strWindowFeatures);
    var win = window.open(url, "_blank");
  }

  function getProfile() {
    var myHeaders = new Headers();
    myHeaders.append("x-access-token", token);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    return fetch(`${API_URL}api/profile`, requestOptions)
      .then((response) => response.text())
      .catch((error) => {});
  }

  function getPoint() {
    var myHeaders = new Headers();
    myHeaders.append("x-access-token", token);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    return fetch(`${API_URL}api/point`, requestOptions)
      .then((response) => response.json())
      .catch((error) => {});
  }

  function getSalesReport() {
    var myHeaders = new Headers();
    myHeaders.append("x-access-token", token);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    return fetch(`${API_URL}api/profile/report`, requestOptions)
      .then((response) => response.json())
      .catch((error) => {});
  }
  
  function getLastUpdate() {

    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };

    return fetch(`${API_URL}api/profile/lastupdate`, requestOptions)
      .then((response) => response.json())
      .catch((error) => {});
  }

  useEffect(async () => {
    let el = document.getElementById("tabs");
    let options = {};
    var instance = M.Tabs.init(el, options);
    setMemberStatus(jwt.decode(token).MemberStatus);
    let response = await getProfile();
    if (response) {
      response = JSON.parse(response);
      if (response.status == 200) {
        await setUser(response.data);
      }
    } else {
      notify();
    }
    let pointresponse = await getPoint();
    if (pointresponse) {
      if (pointresponse.status == 200) {
        setPoint(pointresponse.data);
      }
    } else {
      notify();
    }
  }, []);

  useEffect(async () => {
    let response = await getSalesReport();
    if (response.status == 200 && response.data) {
      setSales(response.data);
    } else {
      // toast.error(response.message)
    }

    let res = await getLastUpdate();
    if (res.status == 200 && res.data) {
      setLastUpdate(res.data);
    } else {
      // toast.error(response.message)
    }
  }, []);

  return (
    <React.StrictMode>
      <Toaster position="bottom-center" />
      <div className="profile-header center">
        <div className="profile-image">
          <img src={avatar} />
        </div>
        <div className="profile-name">{user.Name}</div>
        <div className="profile-email">{user.Email}</div>
        <div className="profile-phone">{user.Phone}</div>
        <div className="profile-point" onClick={() => goToHandler("/point")}>
          Point: {point.PointEnd}
        </div>
        {/* <div className="profile-status">{(memberStatus == "Join") ? `Not a Reseller` : "Reseller"}</div> */}
        {/* <div className="profile-show">
                    <i className="material-icons prefix">remove_red_eye</i>Show Profile
                </div> */}
      </div>
      <div className="shipping-container">
        <div className="row">
          <div className={`col s12`}>
            <ul className="tabs" id="tabs">
              <li className="tab col s4">
                <a href="#test1">
                  {sales.length > 0 && sales[0].MonthName
                    ? sales[0].MonthName
                    : "Loading..."}
                </a>
              </li>
              <li className="tab col s4">
                <a href="#test2">
                  {sales.length > 0 && sales[1].MonthName
                    ? sales[1].MonthName
                    : "Loading..."}
                </a>
              </li>
              <li className="tab col s4">
                <a href="#test3">
                  {sales.length > 0 && sales[2].MonthName
                    ? sales[2].MonthName
                    : "Loading..."}
                </a>
              </li>
            </ul>
          </div>
          <div id={`test1`} className="col s12">
            <div className="report-sales-row">
              Personal Sales (
              {numberWithCommas(
                sales.length > 0 && sales[0].PersonalSelling
                  ? sales[0].PersonalSelling
                  : 0
              )}
              )
            </div>
            <div className="report-sales-row">
              Unit Sales (
              {numberWithCommas(
                sales.length > 0 && sales[0].UnitSales ? sales[0].UnitSales : 0
              )}
              )
            </div>
            <div className="report-sales-row">
              Unit Leader Sales (
              {numberWithCommas(
                sales.length > 0 && sales[0].UnitLeaderSales
                  ? sales[0].UnitLeaderSales
                  : 0
              )}
              )
            </div>
            <div className="report-sales-row">
              Group Sales (
              {numberWithCommas(
                sales.length > 0 && sales[0].GroupSales
                  ? sales[0].GroupSales
                  : 0
              )}
              )
            </div>
            <div className="report-sales-row">
              Personal Recruit (
              {numberWithCommas(
                sales.length > 0 && sales[0].Recruit ? sales[0].Recruit : 0
              )}
              )
            </div>
            {/* <div className="report-sales-row">
              Total Star (
              {numberWithCommas(
                sales.length > 0 && sales[0].Point ? sales[0].Point : 0
              )}
              )
            </div> */}
            <div className="report-sales-row">
              Activity Set 01 (
              {numberWithCommas(
                sales.length > 0 && sales[0].ActivitySet01 ? sales[0].ActivitySet01 : 0
              )}
              )
            </div>
            <div className="report-sales-row">
              Activity Set 02 (
              {numberWithCommas(
                sales.length > 0 && sales[0].ActivitySet02 ? sales[0].ActivitySet02 : 0
              )}
              )
            </div>
            <div className="report-sales-row">
              Activity Set 03 (
              {numberWithCommas(
                sales.length > 0 && sales[0].ActivitySet03 ? sales[0].ActivitySet03 : 0
              )}
              )
            </div>
          </div>
          <div id={`test2`} className="col s12">
            <div className="report-sales-row">
              Personal Sales (
              {numberWithCommas(
                sales.length > 0 && sales[1].PersonalSelling
                  ? sales[1].PersonalSelling
                  : 0
              )}
              )
            </div>
            <div className="report-sales-row">
              Unit Sales (
              {numberWithCommas(
                sales.length > 0 && sales[1].UnitSales ? sales[1].UnitSales : 0
              )}
              )
            </div>
            <div className="report-sales-row">
              Unit Leader Sales (
              {numberWithCommas(
                sales.length > 0 && sales[1].UnitLeaderSales
                  ? sales[1].UnitLeaderSales
                  : 0
              )}
              )
            </div>
            <div className="report-sales-row">
              Group Sales (
              {numberWithCommas(
                sales.length > 0 && sales[1].GroupSales
                  ? sales[1].GroupSales
                  : 0
              )}
              )
            </div>
            <div className="report-sales-row">
              Personal Recruit (
              {numberWithCommas(
                sales.length > 0 && sales[1].Recruit ? sales[1].Recruit : 0
              )}
              )
            </div>
            {/* <div className="report-sales-row">
              Total Star (
              {numberWithCommas(
                sales.length > 0 && sales[1].Point ? sales[1].Point : 0
              )}
              )
            </div> */}
            <div className="report-sales-row">
              Activity Set 01 (
              {numberWithCommas(
                sales.length > 0 && sales[1].ActivitySet01 ? sales[1].ActivitySet01 : 0
              )}
              )
            </div>
            <div className="report-sales-row">
              Activity Set 02 (
              {numberWithCommas(
                sales.length > 0 && sales[1].ActivitySet02 ? sales[1].ActivitySet02 : 0
              )}
              )
            </div>
            <div className="report-sales-row">
              Activity Set 03 (
              {numberWithCommas(
                sales.length > 0 && sales[1].ActivitySet03 ? sales[1].ActivitySet03 : 0
              )}
              )
            </div>
          </div>
          <div id={`test3`} className="col s12">
            <div className="report-sales-row">
              Personal Sales (
              {numberWithCommas(
                sales.length > 0 && sales[2].PersonalSelling
                  ? sales[2].PersonalSelling
                  : 0
              )}
              )
            </div>
            <div className="report-sales-row">
              Unit Sales (
              {numberWithCommas(
                sales.length > 0 && sales[2].UnitSales ? sales[2].UnitSales : 0
              )}
              )
            </div>
            <div className="report-sales-row">
              Unit Leader Sales (
              {numberWithCommas(
                sales.length > 0 && sales[2].UnitLeaderSales
                  ? sales[2].UnitLeaderSales
                  : 0
              )}
              )
            </div>
            <div className="report-sales-row">
              Group Sales (
              {numberWithCommas(
                sales.length > 0 && sales[2].GroupSales
                  ? sales[2].GroupSales
                  : 0
              )}
              )
            </div>
            <div className="report-sales-row">
              Personal Recruit (
              {numberWithCommas(
                sales.length > 0 && sales[2].Recruit ? sales[2].Recruit : 0
              )}
              )
            </div>
            {/* <div className="report-sales-row">
              Total Star (
              {numberWithCommas(
                sales.length > 0 && sales[2].Point ? sales[2].Point : 0
              )}
              )
            </div> */}
            <div className="report-sales-row">
              Activity Set 01 (
              {numberWithCommas(
                sales.length > 0 && sales[2].ActivitySet01 ? sales[2].ActivitySet01 : 0
              )}
              )
            </div>
            <div className="report-sales-row">
              Activity Set 02 (
              {numberWithCommas(
                sales.length > 0 && sales[2].ActivitySet02 ? sales[2].ActivitySet02 : 0
              )}
              )
            </div>
            <div className="report-sales-row">
              Activity Set 03 (
              {numberWithCommas(
                sales.length > 0 && sales[2].ActivitySet03 ? sales[2].ActivitySet03 : 0
              )}
              )
            </div>
          </div>
        </div>
        <div>
          * Last Update: {lastupdate.Value}
        </div>
      </div>
      <div className="profile-menu-list">
        <div
          className="profile-menu-item"
          onClick={() => goToHandler("/Reset")}
        >
          <div className="profile-menu-icon">
            <i className="material-icons prefix">lock</i>
          </div>
          <div className="profile-menu-name">Reset Password</div>
          <div className="profiile-menu-arrow">
            <i className="material-icons prefix">arrow_forward</i>
          </div>
        </div>
        <div
          className="profile-menu-item"
          onClick={() => {
            setIsOpen(true);
          }}
        >
          <div className="profile-menu-icon">
            <i className="material-icons prefix">card_membership</i>
          </div>
          <div className="profile-menu-name">Member Card</div>
          <div className="profiile-menu-arrow">
            <i className="material-icons prefix">arrow_forward</i>
          </div>
        </div>
        <div
          className="profile-menu-item"
          onClick={() => goToHandler("/ChallengeAchievement")}
        >
          <div className="profile-menu-icon">
            <i className="material-icons prefix">local_activity</i>
          </div>
          <div className="profile-menu-name">Challenge Achievement</div>
          <div className="profiile-menu-arrow">
            <i className="material-icons prefix">arrow_forward</i>
          </div>
        </div>
        <div
          className="profile-menu-item"
          onClick={() => goToHandler("/ReportBonus")}
        >
          <div className="profile-menu-icon">
            <i className="material-icons prefix">local_atm</i>
          </div>
          <div className="profile-menu-name">Bonus Report</div>
          <div className="profiile-menu-arrow">
            <i className="material-icons prefix">arrow_forward</i>
          </div>
        </div>
        <div
          className="profile-menu-item"
          onClick={() => goToHandler("/ReportReward")}
        >
          <div className="profile-menu-icon">
            <i className="material-icons prefix">confirmation_number</i>
          </div>
          <div className="profile-menu-name">E-Reward Report</div>
          <div className="profiile-menu-arrow">
            <i className="material-icons prefix">arrow_forward</i>
          </div>
        </div>
        <div
          className="profile-menu-item"
          onClick={() => goToHandler("/NetworkTree")}
        >
          <div className="profile-menu-icon">
            <i className="material-icons prefix">people</i>
          </div>
          <div className="profile-menu-name">Network</div>
          <div className="profiile-menu-arrow">
            <i className="material-icons prefix">arrow_forward</i>
          </div>
        </div>
        <div
          className="profile-menu-item"
          onClick={() => goToHandler("/MemberJoin")}
        >
          <div className="profile-menu-icon">
            <i className="material-icons prefix">person_add</i>
          </div>
          <div className="profile-menu-name">New Member Register</div>
          <div className="profiile-menu-arrow">
            <i className="material-icons prefix">arrow_forward</i>
          </div>
        </div>
        <div
          className="profile-menu-item"
          onClick={() => goToHandler("/RepeatOrder")}
        >
          <div className="profile-menu-icon">
            <i className="material-icons prefix">attach_money</i>
          </div>
          <div className="profile-menu-name">Repeat Order</div>
          <div className="profiile-menu-arrow">
            <i className="material-icons prefix">arrow_forward</i>
          </div>
        </div>
        <div
          className="profile-menu-item"
          onClick={() => goToHandler("/Download")}
        >
          <div className="profile-menu-icon">
            <i className="material-icons prefix">file_download</i>
          </div>
          <div className="profile-menu-name">Download Files</div>
          <div className="profiile-menu-arrow">
            <i className="material-icons prefix">arrow_forward</i>
          </div>
        </div>
        {memberStatus == "Join" ? (
          <div className="profile-menu-item" onClick={UpgradeHandler}>
            <div className="profile-menu-icon">
              <i className="material-icons prefix">trending_up</i>
            </div>
            <div className="profile-menu-name">Upgrade</div>
            <div className="profiile-menu-arrow">
              <i className="material-icons prefix">arrow_forward</i>
            </div>
          </div>
        ) : (
          <></>
        )}
        <div
          className="profile-menu-item"
          onClick={() => goToHandler("/invite")}
        >
          <div className="profile-menu-icon">
            <i className="material-icons prefix">help</i>
          </div>
          <div className="profile-menu-name">Invite Friend</div>
          <div className="profiile-menu-arrow">
            <i className="material-icons prefix">arrow_forward</i>
          </div>
        </div>
        <div
          className="profile-menu-item"
          onClick={() => goToHandlerBlank("https://cs.moorlife.id")}
        >
          <div className="profile-menu-icon">
            <i className="material-icons prefix">help</i>
          </div>
          <div className="profile-menu-name">Contact Support</div>
          <div className="profiile-menu-arrow">
            <i className="material-icons prefix">arrow_forward</i>
          </div>
        </div>
        <div className="profile-menu-item" onClick={LogoutHandler}>
          <div className="profile-menu-icon">
            <i className="material-icons prefix">exit_to_app</i>
          </div>
          <div className="profile-menu-name">Log Out</div>
          <div className="profiile-menu-arrow">
            <i className="material-icons prefix">arrow_forward</i>
          </div>
        </div>
      </div>
      <SlidingPane
        className="cart-expedition-panel"
        closeIcon={
          <span>
            <i className="material-icons">close</i>
          </span>
        }
        isOpen={isOpen}
        title="Member Card"
        from="bottom"
        width="100%"
        onRequestClose={() => setIsOpen(false)}
      >
        <MemberCard />
      </SlidingPane>
      <Footer />
    </React.StrictMode>
  );
};

export default Profile;
